var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "14.1px",
    viewBox: "0 0 100 14.1",
    enableBackground: "new 0 0 100 14.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    x1: 12.3,
    y1: 6.6,
    x2: 12.3,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    d: "M12.3,12.4L12.3,12.4c-0.5,0-0.9-0.4-0.9-0.9v-2 c0-0.5,0.4-0.9,0.9-0.9h0c0.5,0,0.9,0.4,0.9,0.9v2C13.1,12,12.7,12.4,12.3,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    x1: 69.4,
    y1: 6.6,
    x2: 69.4,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    d: "M69.4,12.4L69.4,12.4c-0.5,0-0.9-0.4-0.9-0.9v-2 c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v2C70.2,12,69.8,12.4,69.4,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    x1: 30.6,
    y1: 6.6,
    x2: 30.6,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    d: "M30.6,12.4L30.6,12.4c-0.5,0-0.9-0.4-0.9-0.9v-2 c0-0.5,0.4-0.9,0.9-0.9h0c0.5,0,0.9,0.4,0.9,0.9v2C31.5,12,31.1,12.4,30.6,12.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    x1: 87.9,
    y1: 6.6,
    x2: 87.9,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    d: "M87.9,12.4L87.9,12.4c-0.5,0-0.9-0.4-0.9-0.9v-2 c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v2C88.8,12,88.4,12.4,87.9,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    x1: 50,
    y1: 6.6,
    x2: 50,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.7455,
    d: "M50,12.4L50,12.4c-0.5,0-0.9-0.4-0.9-0.9v-2 c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v2C50.9,12,50.5,12.4,50,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 1.7,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.994,
    width: 98.8,
    height: 4.9
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackicon);
export default __webpack_public_path__ + "static/media/trackicon.0be4a9a8a1dd53e9a0829185fe3d7e70.svg";
export { ForwardRef as ReactComponent };